import { useHistory } from 'react-router-dom';
import styles from './StudentFooter.module.scss';
import backpackLogo from '../../images/pkp-logo-bookmark-no-text.svg';

const StudentFooter = (): JSX.Element => {
  const history = useHistory();
  return (
    <div className={styles.container}>
      <img
        onClick={() => history.push('/studentportal/todos')}
        src={backpackLogo}
        alt='backpack logo'
        className={styles.logo}
      />
    </div>
  );
};

export default StudentFooter;
